export enum TipoResponsavelUsuario {
  ADMINISTRADOR = 1,
  MASTER,
  VISUALIZADOR,
  SAC,
  RASTREAMENTO,
}
